define('modules/products/collection',['require','exports','module','app','env'],function (require, exports, module) {
  "use strict";

  var app = require("app");
  var Config = require("env");

  var Collection = Backbone.Collection.extend({
    url: function () {
      var url = Config.backendUrl + "/products";
      if (this.groupId !== undefined && this.groupId !== "0") {
        url = url + "/group/" + this.groupId;
      }
      return url;
    },
    parse: function (response, options) {
      var products = response._embedded.products;
      return products;
    },
    getMyCompanies: function () {
      var companies = [];
      _.each(
        this.models,
        function (model) {
          if (model.get("activeServiceUser")) {
            _.each(
              model.get("companies"),
              function (company) {
                var found = _.find(
                  companies,
                  function (cmp) {
                    return cmp.id === company.id;
                  },
                  this
                );

                if (company.activeServiceCompany && found === undefined) {
                  companies.push(company);
                }
              },
              this
            );
          }
        },
        this
      );

      return companies;
    },
    setGroupId: function (groupId) {
      this.groupId = groupId;
    },
    getFirstCompanyFromService: function (service) {
      var company;
      var product = _.find(
        this.models,
        function (model) {
          return service === model.get("name");
        },
        this
      );

      var productCompanies = product.get("companies");
      company = _.find(productCompanies, function (cmp) {
        return cmp.activeServiceCompany === true;
      });

      return company;
    },
    groupHasService: function (service) {
      var found = _.find(this.models, function (currentService) {
        return (
          currentService.get("name") === service &&
          currentService.get("companies").length > 0
        );
      });

      return found === undefined ? false : true;
    },
    getService: function (serviceName) {
      var service = _.find(
        this.models,
        function (currentService) {
          return currentService.get("name") === serviceName;
        },
        this
      );

      return service;
    },
    anyCompanyIsActive: function (serviceName) {
      var active = false;
      var service = this.getService(serviceName);

      if (service !== undefined) {
        var companies = service.get("companies");
        _.each(
          companies,
          function (company) {
            active = active || company.status;
          },
          this
        );
      }
      return active;
    },
  });

  module.exports = Collection;
});

